module.exports = __webpack_public_path__ + "static/media/feat9en@3x.61bad90c.png";